@import (reference) '../../../../../constants/spacing.module.less';

.sidebar {
  width: 240px;
  min-width: 240px;
  border-right: 1px solid var(--grey-300);
  overflow-y: auto;
  background-color: var(--white);
}

.product-info {
  padding: @space-16;
  border-bottom: 1px solid var(--grey-300);
  align-items: center;
}

.product-image {
  width: 80px;
  height: 80px;
  object-fit: contain;
  border-radius: 6px;
  border: 1px solid var(--grey-300);
}

.product-image-placeholder {
  width: 80px;
  height: 80px;
  background-color: var(--grey-100);
  border-radius: 6px;
  border: 1px solid var(--grey-300);
}

.product-name {
  font-weight: 600;
  text-align: center;
  color: var(--grey-900);
}

.product-sku {
  color: var(--grey-600);
  text-align: center;
}

.nav {
  padding: @space-8 @space-16;
  flex: 1;
}

.nav-item-base() {
  width: 100%;
  text-align: left;
  padding: @space-8 @space-12;
  cursor: pointer;
}

.nav-item {
  .nav-item-base();
  border-radius: 0;
  color: var(--grey-800);
  background-color: transparent;

  &:hover {
    background-color: var(--grey-100);
  }
}

.active-nav-item {
  .nav-item-base();
  border-radius: var(--Radius-XS, 4px);
  background-color: var(--green-00331C, #00331c);
  color: var(--white);
  font-weight: 600;

  &:hover,
  &:disabled {
    background-color: var(--green-00331C, #00331c);
    opacity: 1;
    cursor: default;
  }
}
